import { createContext } from 'react'

export interface PlanIds {
  accountId: number
  branchId: number
}

// Supplies account/branch ids when the plan is mounted inline in the legacy app, where the
// host route (`/plan`) carries no ids in the URL for foresight's useParams() to read.
export const PlanIdsContext = createContext<PlanIds | null>(null)
